function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadge4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E68900"
    },
    points: "394.827,348.588 327.842,345.626 335.247,418.117 376.558,463.238 443.254,465.502 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFAD00"
    },
    points: "285.067,401.113 330.999,512 376.558,463.238 327.842,345.626 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E68900"
    },
    points: "231.519,395.086 186.248,345.626 140.225,402.122 137.532,463.238 183.091,512 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFAD00"
    },
    points: "119.26,348.593 70.836,465.502 137.532,463.238 186.248,345.626 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE2A"
    },
    d: "M254.955,0l-20.899,201.532l20.899,201.531c111.303,0,201.532-90.229,201.532-201.532 S366.258,0,254.955,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDEB95"
    },
    d: "M55.513,201.532c0,111.303,90.229,201.532,201.532,201.532V0C145.742,0,55.513,90.229,55.513,201.532 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E68900"
    },
    d: "M257.045,45.098l-20.899,156.434l20.899,156.433c86.258,0,156.434-70.175,156.434-156.434 C413.479,115.273,343.303,45.098,257.045,45.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAD00"
    },
    d: "M100.611,201.531c0,86.258,70.175,156.434,156.434,156.434V45.098 C170.786,45.098,100.611,115.273,100.611,201.531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6CD800"
    },
    d: "M315.279,162.202c-6.013,0-14.11,1.354-22.672,3.768c2.413-8.562,3.768-16.659,3.768-22.672 c0-21.721-17.609-39.329-39.329-39.329l-22.077,97.564l22.076,97.562c21.721,0,39.329-17.609,39.329-39.329 c0-6.013-1.354-14.11-3.768-22.672c8.562,2.413,16.659,3.768,22.672,3.768c21.721,0,39.33-17.609,39.33-39.329 C354.609,179.81,337,162.202,315.279,162.202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93F340"
    },
    d: "M217.716,143.296c0,6.013,1.354,14.11,3.768,22.672c-8.562-2.413-16.659-3.768-22.672-3.768 c-21.721,0-39.33,17.609-39.33,39.33s17.609,39.329,39.33,39.329c6.013,0,14.11-1.354,22.672-3.768 c-2.413,8.562-3.768,16.659-3.768,22.672c0,21.721,17.609,39.329,39.329,39.329V103.967 C235.324,103.967,217.716,121.576,217.716,143.296z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge4);
export default __webpack_public_path__ + "static/media/badge4.c5bd20d3a321c65584661f0279a79eea.svg";
export { ForwardRef as ReactComponent };